import { useContext } from "react"
import { AuthContext } from "../context/AuthContext";

export const useAuth = () => {
    const ctx = useContext(AuthContext);
    if (ctx) {
        return ctx
    } else {
        throw new Error("Auth context not found!");
        
    }
}